import { MinimalSymbol } from 'features/processFlowDiagrams/data/MinimalSymbols'
import JetPumpLiquid from 'features/processFlowDiagrams/svg/pumps-iso/jet-pump-liquid.svg?react'
import PumpCentrifugal from 'features/processFlowDiagrams/svg/pumps-iso/pump-centrifugal.svg?react'
import PumpDiaphragm from 'features/processFlowDiagrams/svg/pumps-iso/pump-diaphragm.svg?react'
import PumpGear from 'features/processFlowDiagrams/svg/pumps-iso/pump-gear.svg?react'
import PumpLiquid from 'features/processFlowDiagrams/svg/pumps-iso/pump-liquid.svg?react'
import PumpPositiveDisplacement from 'features/processFlowDiagrams/svg/pumps-iso/pump-positive-displacement.svg?react'
import PumpProgressiveCavity from 'features/processFlowDiagrams/svg/pumps-iso/pump-progressive-cavity.svg?react'
import PumpReciprocatingPiston from 'features/processFlowDiagrams/svg/pumps-iso/pump-reciprocating-piston.svg?react'
import PumpScrew from 'features/processFlowDiagrams/svg/pumps-iso/pump-screw.svg?react'
import React from 'react'

export const PID_PUMPS_ISO_SYMBOLS: MinimalSymbol[] = [
  {
    id: 'jet-pump-liquid',
    name: 'Jet Pump (Liquid)',
    category: 'pumps-iso',
    svgContent: <JetPumpLiquid />,
    viewBox: '0 0 100 100',
  },
  {
    id: 'pump-centrifugal',
    name: 'Pump (Centrifugal)',
    category: 'pumps-iso',
    svgContent: <PumpCentrifugal />,
    viewBox: '0 0 100 100',
  },
  {
    id: 'pump-diaphragm',
    name: 'Pump (Diaphragm)',
    category: 'pumps-iso',
    svgContent: <PumpDiaphragm />,
    viewBox: '0 0 100 100',
  },
  {
    id: 'pump-gear',
    name: 'Pump (Gear)',
    category: 'pumps-iso',
    svgContent: <PumpGear />,
    viewBox: '0 0 100 100',
  },
  {
    id: 'pump-liquid',
    name: 'Pump (Liquid)',
    category: 'pumps-iso',
    svgContent: <PumpLiquid />,
    viewBox: '0 0 100 100',
  },
  {
    id: 'pump-positive-displacement',
    name: 'Pump (Positive Displacement)',
    category: 'pumps-iso',
    svgContent: <PumpPositiveDisplacement />,
    viewBox: '0 0 100 100',
  },
  {
    id: 'pump-progressive-cavity',
    name: 'Pump (Progressive Cavity)',
    category: 'pumps-iso',
    svgContent: <PumpProgressiveCavity />,
    viewBox: '0 0 100 100',
  },
  {
    id: 'pump-reciprocating-piston',
    name: 'Pump (Reciprocating Piston)',
    category: 'pumps-iso',
    svgContent: <PumpReciprocatingPiston />,
    viewBox: '0 0 100 100',
  },
  {
    id: 'pump-screw',
    name: 'Pump (Screw)',
    category: 'pumps-iso',
    svgContent: <PumpScrew />,
    viewBox: '0 0 100 100',
  },
]
